export const CopyRecipientsModal: string = 'CopyRecipientsModal';
